import { create } from 'zustand';
export const useLayoutStore = create((set)=>({
        pageHeaderContent: null,
        setPageHeaderContent: (content)=>set({
                pageHeaderContent: content
            }),
        clearPageHeaderContent: ()=>set({
                pageHeaderContent: null
            }),
        showBreadcrumbs: true,
        setShowBreadcrumbs: (show)=>set({
                showBreadcrumbs: show
            }),
        showHeader: true,
        setShowHeader: (show)=>set({
                showHeader: show
            }),
        breadcrumbItems: null,
        setBreadcrumbItems: (items)=>set({
                breadcrumbItems: items
            }),
        assistOpen: false,
        setAssistOpen: (open)=>set({
                assistOpen: open
            }),
        toggleAssist: ()=>set((s)=>({
                    assistOpen: !s.assistOpen
                })),
        assistOrigin: null,
        setAssistOrigin: (path)=>set({
                assistOrigin: path
            }),
        sidebarCollapsed: false,
        setSidebarCollapsed: (collapsed)=>set({
                sidebarCollapsed: collapsed
            }),
        toggleSidebarCollapsed: ()=>set((s)=>({
                    sidebarCollapsed: !s.sidebarCollapsed
                })),
        chatRailCollapsed: false,
        setChatRailCollapsed: (collapsed)=>set({
                chatRailCollapsed: collapsed
            }),
        toggleChatRailCollapsed: ()=>set((s)=>({
                    chatRailCollapsed: !s.chatRailCollapsed
                }))
    }));
